import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { PlatformService } from '../services/platform/platform.service';
import { LangTgtService } from '../services/lang-tgt/lang-tgt.service';
import { LangSrcService } from '../services/lang-src/lang-src.service';
import { ConfigService } from '../services/config/config.service';
import { EvaluationService } from '../services/evaluation/evaluation.service';

@Injectable({
  providedIn: 'root'
})
export class EvaluationGuard {

  constructor(
    private router: Router,
    private platformSrv: PlatformService,
    private langTgtSrv: LangTgtService,
    private langSrcSrv: LangSrcService,
    private configSrv: ConfigService,
    private evaluationSrv: EvaluationService,
  ) {}

  async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    const code = this.platformSrv.platform?.key;
    if (!code) {
      return true;
    }

    const langTgt = this.langTgtSrv.langs?.find(l => l.code === code);
    if (!langTgt) {
      return true;
    }

    if (!this.configSrv.config?.informations?.evaluationActive || !langTgt.evaluationActive) {
      return true;
    }

    const completed = await this.evaluationSrv.completed(code);
    if (completed) {
      return true;
    }

    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'evaluation', code]);
    return false;
  }
}
